import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import "./CPForm.css"; // <-- We'll use a dedicated CSS file for styling
import Navbar from '../../../../examples/Navigation/Navbar.jsx';
import Footer from '../../../../examples/Footers/Footer/footer.jsx'; 
import CareerBannerImage from "assets/images/CareerPage/CareerBanner.jpg";
// import CPbanner from "./CPbanner";
// import { useNavigate } from "react-router-dom";

const CPForm = () => {
  // const navigate = useNavigate();
  // State for form data
  const [formData, setFormData] = useState({
    position: "",
    nationality: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    resume: null,
    checkbox1: false,
    checkbox2: false,
  });

  // State for form errors
  const [formErrors, setFormErrors] = useState({});

  // Validate form fields
  const validateForm = () => {
    const errors = {};

    // Position
    if (!formData.position) {
      errors.position = "Position is required.";
    }

    // Nationality
    if (!formData.nationality) {
      errors.nationality = "Nationality is required.";
    }

    // First Name
    if (!formData.firstName) {
      errors.firstName = "First Name is required.";
    }
    // Last Name
    if (!formData.lastName) {
      errors.lastName = "Last Name is required.";
    }

    // Email
    if (!formData.email) {
      errors.email = "Email Address is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Email Address is invalid.";
    }

    // Phone Number
    if (!formData.phoneNumber) {
      errors.phoneNumber = "Phone Number is required.";
    }

    // Resume
    if (!formData.resume) {
      errors.resume = "Resume is required.";
    } else if (formData.resume.type !== "application/pdf") {
      errors.resume = "Only PDF files are allowed for resume upload.";
    }

    // Checkboxes
    if (!formData.checkbox1) {
      errors.checkbox1 = "You must agree to the first statement.";
    }
    if (!formData.checkbox2) {
      errors.checkbox2 = "You must agree to the second statement.";
    }

    return errors;
  };

  // Handle changes in input fields
  const handleChange = (e) => {
    const { name, value, files, type, checked } = e.target;

    if (type === "file") {
      setFormData({
        ...formData,
        [name]: files[0],
      });
    } else if (type === "checkbox") {
      setFormData({
        ...formData,
        [name]: checked,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  // Submit form data
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate the form
    const errors = validateForm();
    if (Object.keys(errors).length === 0) {
      const formDataToUpload = new FormData();
      formDataToUpload.append("position", formData.position);
      formDataToUpload.append("nationality", formData.nationality);
      formDataToUpload.append("firstName", formData.firstName);
      formDataToUpload.append("lastName", formData.lastName);
      formDataToUpload.append("email", formData.email);
      formDataToUpload.append("phoneNumber", formData.phoneNumber);
      formDataToUpload.append("resume", formData.resume);

      try {
        const response = await axios.post(
          "https://squarecloudasia.com/upload-and-email.php",
          formDataToUpload,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        console.log("Backend Response:", response.data);

        // Validate the backend response structure
        if (response.data && typeof response.data.success !== "undefined") {
          if (response.data.success) {
            Swal.fire({
              icon: "success",
              title: "Application Sent!",
              text:
                response.data.message ||
                "Your application has been submitted successfully.",
            });
            // Clear form data
            setFormData({
              position: "",
              nationality: "",
              firstName: "",
              lastName: "",
              email: "",
              phoneNumber: "",
              resume: null,
              checkbox1: false,
              checkbox2: false,
            });
            // Optionally close the form after successful submission
            // onClose();
          } else {
            Swal.fire({
              icon: "error",
              title: "Error!",
              text:
                response.data.message ||
                "An error occurred. Please try again later.",
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "Unexpected response from the server. Please contact support.",
          });
        }
      } catch (error) {
        console.error("Submission error:", error);

        Swal.fire({
          icon: "error",
          title: "Error!",
          text:
            error.response?.data?.message ||
            "Failed to submit the application. Please try again later.",
        });
      }
    } else {
      setFormErrors(errors);
    }
  };

  return (
    <>
    <Navbar />
    
    <MKBox
      position="relative"
      width="100%"
      height="55vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      {/* Background Image */}
      <img
        src={CareerBannerImage}
        alt="Career Banner"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center",
        }}
      />

      {/* Banner Text */}
      <MKTypography
        variant="h1"
        component="div"
        color="white"
        sx={{
          position: "absolute",
          fontSize: { xs: "3rem", sm: "4rem", md: "5rem" },
          fontWeight: "bold",
          mt: 8,
          textAlign: "center",
          textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
        }}
      >
        Your Career Starts Here
      </MKTypography>
    </MKBox>
    {/* <div className="cp-back-button-container">
        <button className="cp-back-button" onClick={() => navigate(-1)}>
          <svg viewBox="0 0 24 24">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
          Back
        </button>
      </div> */}
    <div className="cpform-container">
      <form className="career-application-form" onSubmit={handleSubmit}>
        {/* Position Applied */}
        <div className="career-form-group">
          <label htmlFor="position">Position Applied</label>
          <select
            id="position"
            name="position"
            value={formData.position}
            onChange={handleChange}
          >
            <option value="">-- Select Position --</option>
            <option value="Software Developer">Software Developer</option>
            <option value="Data Analyst">Data Analyst</option>
            <option value="Chargeman">Chargeman</option>
          </select>
          {formErrors.position && (
            <span className="error">{formErrors.position}</span>
          )}
        </div>

        {/* Nationality */}
        <div className="career-form-group">
          <label htmlFor="nationality">Nationality</label>
          <input
            type="text"
            id="nationality"
            name="nationality"
            placeholder="Enter your nationality"
            value={formData.nationality}
            onChange={handleChange}
          />
          {formErrors.nationality && (
            <span className="error">{formErrors.nationality}</span>
          )}
        </div>

        {/* First Name */}
        <div className="career-form-group">
          <label htmlFor="firstName">First Name</label>
          <input
            id="firstName"
            type="text"
            name="firstName"
            placeholder="Enter your first name"
            value={formData.firstName}
            onChange={handleChange}
          />
          {formErrors.firstName && (
            <span className="error">{formErrors.firstName}</span>
          )}
        </div>

        {/* Last Name */}
        <div className="career-form-group">
          <label htmlFor="lastName">Last Name</label>
          <input
            id="lastName"
            type="text"
            name="lastName"
            placeholder="Enter your last name"
            value={formData.lastName}
            onChange={handleChange}
          />
          {formErrors.lastName && (
            <span className="error">{formErrors.lastName}</span>
          )}
        </div>

        {/* Email Address */}
        <div className="career-form-group">
          <label htmlFor="email">Email Address</label>
          <input
            id="email"
            type="email"
            name="email"
            placeholder="Enter your email address"
            value={formData.email}
            onChange={handleChange}
          />
          {formErrors.email && <span className="error">{formErrors.email}</span>}
        </div>

        {/* Phone Number */}
        <div className="career-form-group">
          <label htmlFor="phoneNumber">Phone Number</label>
          <input
            id="phoneNumber"
            type="tel"
            name="phoneNumber"
            placeholder="Enter your phone number"
            value={formData.phoneNumber}
            onChange={handleChange}
          />
          {formErrors.phoneNumber && (
            <span className="error">{formErrors.phoneNumber}</span>
          )}
        </div>

        {/* Upload Resume */}
        <div className="career-form-group">
          <label htmlFor="resume">Upload Resume (PDF only)</label>
          <input
            id="resume"
            type="file"
            name="resume"
            accept=".pdf"
            onChange={handleChange}
          />
          {formErrors.resume && <span className="error">{formErrors.resume}</span>}
        </div>

        {/* Checkbox 1 */}
        <div className="career-form-group checkbox-group">
          <input
            id="checkbox1"
            type="checkbox"
            name="checkbox1"
            checked={formData.checkbox1}
            onChange={handleChange}
          />
          <label htmlFor="checkbox1" className="checkbox-label">
            I hereby affirm that the information provided in this application is
            true and correct. I understand that any false or misleading
            information may result in disqualification of my application or
            revocation of any offer of employment. I also authorize the company
            to contact my referees, friends, or past employers for verification
            of my background.
          </label>
          {formErrors.checkbox1 && (
            <span className="error">{formErrors.checkbox1}</span>
          )}
        </div>

        {/* Checkbox 2 */}
        <div className="career-form-group checkbox-group">
          <input
            id="checkbox2"
            type="checkbox"
            name="checkbox2"
            checked={formData.checkbox2}
            onChange={handleChange}
          />
          <label htmlFor="checkbox2" className="checkbox-label">
            By submitting this application, I consent to the company’s collection,
            use, processing, and retention of my personal data for the purpose
            of evaluating my application and suitability for the position. I also
            agree that the company may retain my personal data for consideration
            for future positions that may arise from time to time.
          </label>
          {formErrors.checkbox2 && (
            <span className="error">{formErrors.checkbox2}</span>
          )}
        </div>

        {/* Submit & Cancel Buttons */}
        <div className="button-row">
          <button type="submit" className="career-submit-button">
            Submit Application
          </button>
        </div>
      </form>
    </div>
    <Footer />
    </>
  );
};

CPForm.propTypes = {
  onClose: PropTypes.func.isRequired, // or PropTypes.func if optional
};

export default CPForm;
